import noUiSlider from 'nouislider/distribute/nouislider.js';
import 'nouislider/distribute/nouislider.css';
export default noUiSlider;